import { GetApiV5FilesIdTagSuggestions200 } from 'api/v5/schemas';

export const mapTagSuggestions = (
  suggestionsResponse?: GetApiV5FilesIdTagSuggestions200,
): TagOption[] =>
  suggestionsResponse?.suggestions.map((suggestion) => ({
    key: suggestion,
    label: suggestion,
  })) || [];
